import React from 'react'
import styles from './ReservationPage.module.css'
import ReservationSection from '../../sections/ReservationSection/ReservationSection'

const ReservationPage = () => {
    return (
        <div className={styles.Main}>
            <ReservationSection/>
        </div>
    )
}

export default ReservationPage